import React from "react";

import { useTranslation } from "utils";

import { ScenarioData } from "pages/app/scenario-analysis/types/scenario";
import { scenarioLineColor } from "pages/app/scenario-analysis/utils/forecast";

type ScenarioLegendItemProps = {
  scenarios: ScenarioData[];
  scenario: ScenarioData;
};

export const ScenarioLegendItem = ({ scenarios, scenario }: ScenarioLegendItemProps) => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <span className="pdf-legend-item">
      <span className="pdf-legend-dot" style={{ background: scenarioLineColor(scenarios, scenario.id) }} aria-hidden />
      <span className="pdf-legend-label">{scenario.title}</span>
      {scenario.isReference && <span className="pdf-baseline-tag">{t("pdfReport.baseline")}</span>}
    </span>
  );
};
